<template>
  <editCondition :condition="rule" :loading="loading" />
</template>
<script>
import editCondition from '@/pages/conditions/add'
import { getCondition } from '@/api/conditions'
export default {
  data() {
    return {
      rule: null,
      loading: true,
    }
  },
  components: {
    editCondition,
  },
  created() {
    getCondition.api(this.$route.params.id).then((res) => {
      this.rule = {
        ...res,
        id: this.$route.params.id,
        disabled: this.$route.name.includes('VIEW') ? true : false,
      }
      this.loading = false
    })
  },
}
</script>
